import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import examples from '../../../utils/examples';
import urlHandler from '../../../utils/urlHandler';

class DocV2EntitiesCreate extends Component {
    constructor(props){
        super(props);
    }        

    render() {
        return (
            <div className="bucket" id="top">
                <h3 className="heading-1">Create Entities</h3>
                <code className="api-definition">
                    <span className="post-badge">POST</span>&nbsp;{urlHandler.API_ENDPOINT_V2_ENTITIES}/{'{'}knowledgebase{'}'}
                </code>
                <div className="description">
                    <br/>
                    <b>Create New Knowledgebase Entity</b><br/>
                    <br/>

                    The entities POST request creates a new entity of the type provided in the appropriate 
                    knowledgebase. Entity types THING, PERSON and ORGANIZATION are currently supported.<br/>
                    <br/>
                    A JSON object representing the new entity is sent as the payload. 
                    Available <Link to="/documentation/doc_kbattributes">entity fields</Link> will vary by entity type.<br/>
                    <br/>
                    The THING endpoint requires entities include the "type" field in the request object. The type string can be "THING" or a custom string consisting of uppercase letters and underscores.<br/>
                    <br/>
                    The PERSON and ORGANIZATION endpoint do not require entites include the type field and do not support custom type strings. Only "PERSON" and "ORGANIZATION" type are supported respectively.<br/>
                    <br/>
                    The request returns a status code 201 (HTTP Created) and a JSON representation of the new entity in the 
                    response body with its assigned entity id.<br/> 

                    <div className="deprecated">
                        <span className="fa fa-exclamation-triangle">&nbsp;</span>
                        This request is only available to on-prem customers of Finch For Text.
                    </div>
                    
                </div>

                <h4 className="heading-2">Request</h4>

                <h4 className="heading-3"> URL Parameters</h4>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Values </th>
                        <th>Default </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">knowledgebase</td>
                        <td className="meaning">The name of the Finch knowledgebase entity type. Valid values: THING, PERSON or ORGANIZATION.
                        </td>
                        <td className="type">String</td>
                        <td className="constraints">Required</td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-3" id="enrichv2_request_object">Request object</h4>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Values </th>
                        <th>Default </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">label</td>
                        <td className="meaning">The typically used name of the entity.
                        </td>
                        <td className="type">String</td>
                        <td className="constraints">Required</td>
                    </tr>
                    <tr>
                        <td className="attribute">type</td>
                        <td className="meaning">The type of entity.
                        </td>
                        <td className="type">String</td>
                        <td className="constraints">Required: THING endpoint<br/>
                        Optional: PERSON & ORGANIZATION endpoints <br/></td>
                    </tr>
                    <tr>
                        <td className="attribute">document</td>
                        <td className="meaning">A UTF-8 text document describing the entity. Document must be at least 256 chars.</td>
                        <td className="type">String</td>
                        <td className="constraints">Required</td>
                    </tr>
                    <tr>
                        <td className="attribute">description</td>
                        <td className="meaning">A UTF-8 short description for the entity.</td>
                        <td className="type">String</td>
                        <td className="constraints">Required</td>
                    </tr>
                    <tr>
                        <td className="attribute">prominence</td>
                        <td className="meaning">The news prominence of the entity. Decimal value in the range 0.0 to 1.0.</td>
                        <td className="type">Decimal</td>
                        <td className="constraints">Required</td>
                    </tr>
                    <tr>
                        <td className="attribute">nameVariations</td>
                        <td className="meaning">An array of string values that represent common names used for the entity.</td>
                        <td className="type">String[]</td>
                        <td className="constraints">Required</td>
                    </tr>
                    <tr>
                        <td className="attribute">userData</td>
                        <td className="meaning">A string representation of a JSON object containing user-defined 
                            attributes. The JSON object may contain nested objects and arrays, but must be valid JSON syntax.
                        </td>
                        <td className="type">String</td>
                        <td className="constraints">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute"><i>other fields</i></td>
                        <td className="meaning">Other fields may be provided that relate to the entity being created.
                        </td>
                        <td className="type">See supported <Link to="/documentation/doc_kbattributes">entity fields</Link>.</td>
                        <td className="constraints">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute"><i>prohibited fields</i></td>
                        <td className="meaning">Fields that are generated during the create process that are not 
                            allowed to be present in the request object. If you copy an existing KB entity to use as 
                            a template for a new entity being created, you must remove these fields.
                        </td>
                        <td className="type">See supported <Link to="/documentation/doc_kbattributes">entity fields</Link></td>
                        <td className="constraints">Prohibited fields include:<br/>
                            <br/>
                            <i>newsTopics</i><br/>
                            <i>proximityContext</i><br/>
                            <i>personNames</i><br/>
                            <i>orgNames</i><br/>
                            <i>names</i><br/>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-3">Example</h4>
                <div className="example-content host">
                    <pre>
                    POST {urlHandler.API_ENDPOINT_V2_ENTITIES}/THING<br/>
                    Accept: application/JSON<br/>
                    Authorization: Bearer [YOUR-API-KEY]<br/>
                    Content-Type: application/json<br/>
                    <br/>
                    {JSON.stringify(examples.EXAMPLE_REQUEST_V2_ENTITIES_CREATE, null, 3)}
                    </pre>
                </div>

                <h4 className="heading-2">Response</h4>

                <h4 className="heading-3">Response object</h4>
                <div className="description">
                    The create entity response object contains a JSON representation of the new entity in the 
                    response body with its assigned entity id as well as a <i>location</i> header field containing a 
                    URI to retrieve the new entity.
                </div>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Values </th>
                        <th>Default </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">id</td>
                        <td className="meaning">The unique identifier assigned to the new entity.
                        </td>
                        <td className="type">String</td>
                        <td className="constraints">Required</td>
                    </tr>
                    <tr>
                        <td className="attribute">version</td>
                        <td className="meaning">The version for the created entity.</td>
                        <td className="type">String</td>
                        <td className="constraints">Required</td>
                    </tr>
                    <tr>
                        <td className="attribute"><i>other fields</i></td>
                        <td className="meaning">Other fields may be provided that relate to the entity being created.
                        </td>
                        <td className="type">See supported <Link to="/documentation/doc_kbattributes">entity fields</Link>.</td>
                        <td className="constraints">Optional</td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-3">Example</h4>
                <div className="example-content host">
                    <pre>
                        {JSON.stringify(examples.EXAMPLE_RESPONSE_V2_ENTITIES_CREATE, null, 3)}
                    </pre>
                </div>

                <h4 className="heading-2">Error Responses</h4>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Code </th>
                        <th>Status Text </th>
                        <th>Description </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">400</td>
                        <td className="status-text">Bad Request</td>
                        <td className="notes">Check for invalid entity type or JSON.</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

export default DocV2EntitiesCreate;